
import { Prop, Vue, Component } from 'vue-property-decorator';
import { ActivityHourMapDTO, TableHeaderColumns } from '@/models';

@Component
export default class ManuallyInputSummary extends Vue {
  @Prop() manuallyInput: ActivityHourMapDTO;

  headers: TableHeaderColumns = [
    {
      value: 'activityName',
      text: 'Activity Name'
    },
    {
      value: 'totalHourTask',
      text: 'Total Hour'
    }
  ];

  get tableData(): Array<{ activityName: string; totalHourTask: number }> {
    if (!this.manuallyInput) return [];
    const temp = Object.entries(this.manuallyInput)
      .filter(([activityName, totalHourTask]) => totalHourTask > 0)
      .map(([activityName, totalHourTask]) => ({
        activityName,
        totalHourTask
      }));
    return temp;
  }

  get totalHours(): number {
    return Object.values(this.manuallyInput).reduce((acc, val) => acc + val, 0);
  }
}
